import { LanguageCode } from 'src/types'

import cn from '../../../../assets/images/common/flags/cn@2x.png'
import de from '../../../../assets/images/common/flags/de@2x.png'
import en from '../../../../assets/images/common/flags/en@2x.png'
import es from '../../../../assets/images/common/flags/es@2x.png'
import fr from '../../../../assets/images/common/flags/fr@2x.png'
import it from '../../../../assets/images/common/flags/it@2x.png'
import jp from '../../../../assets/images/common/flags/jp@2x.png'
import ru from '../../../../assets/images/common/flags/ru@2x.png'
import other from '../../../../assets/images/common/flags/other@2x.png'

const FLAG_MAP = {
  cn,
  de,
  en,
  es,
  fr,
  it,
  jp,
  ru,
  other,
}

export const getFlagIcon = (l2Code: LanguageCode): string => {
  return FLAG_MAP[l2Code] || FLAG_MAP.other
}
